import React, {useEffect, useRef, useState} from 'react';
import {useFieldArray} from 'react-hook-form';
import Input from '../global/Input';
import {Button} from 'primereact/button';
import {useGetCommentTypesQuery, useGetKontaktTypesQuery} from '../../redux/rtk/injectedPersonApi';
import {CustomConfirmDialog} from '../global/CustomConfirmDialog';
import {TabPanel, TabView} from 'primereact/tabview';
import {classNames} from 'primereact/utils';
import CommentHistory from '../global/CommentHistory';
import {AccordionTab} from 'primereact/accordion';
import moment from 'moment';
import {getUserFromLocalStorage} from '../functions/Global';

type AddressProps = {
    projectId: string,
    type: string,
    t: any,
    getFormErrorMessage: (name: string) => void,
    form: any,
    edit: boolean,
    kommentare: any[],
}

export const CommentForm = (props: AddressProps) => {
    const t = props.t;

    const [selectedCommentType, setSelectedCommentType] = useState<number | undefined>(undefined);

    const commentTypesQuery = useGetCommentTypesQuery({type: props.type});

    const {control, formState: {errors}, handleSubmit, setValue, getValues, watch} = props.form;

    const id = 'kommentar';

    const {fields, append, prepend, remove, swap, move, insert} = useFieldArray({
        control, // control props comes from useForm (optional: if you are using FormContext)
        name: id, // unique name for your Field Array
    });

    const getCommentTypeName = (id: number | undefined) => {
        let result = '';

        if (commentTypesQuery.data && id) {
            let item = commentTypesQuery.data.find((item: any) => {
                return item.id === id;
            });

            if (item) {
                result = item.name;
            }
        }

        return result;
    };

    const getCommentField = (item: any, index: number) => {

        return (<>
            <div className={classNames('p-2 flex', index > 0 ? 'mt-4' : '')}>
                <div className={'font-bold mr-3 my-auto'}>{item.type}</div>
                <div
                    className={'my-auto'}>{moment(item.zeitstempel).format(t('datetimeformat')) + ' (' + item.ersteller + ')'}</div>
                <Button className={'p-button-rounded p-button-danger p-button-text mt-auto'}
                        style={{float: 'right'}}
                        type={'button'}
                        icon={'pi pi-trash'}
                        disabled={!props.edit}
                        onClick={() => {
                            CustomConfirmDialog({
                                message: t('globalData:dialogs.deleteComment'),
                                header: t('confirmDialog:deleteDialogHeader'),
                                translation: t,
                                onConfirm: () => {
                                    remove(index);
                                }
                            });
                        }}/>
            </div>
            <Input edit={true} type={'textarea'} name={`${id}.${index}.kommentar`}
                   validationControl={control}
                   validationErrorMessage={props.getFormErrorMessage}
                   validationRules={{required: false}}/></>);
    };

    return (<>
            <div className={'grid'}>
                <div className={'col-6'}>
                    <Input edit={true} name={'commenttype'} type={'dropdown'} value={selectedCommentType}
                           onChange={(e: any) => {
                               setSelectedCommentType(e.target.value);
                           }}
                           dropdownOptions={commentTypesQuery.data && commentTypesQuery.data.map((item: any) => {
                               return {value: item.id, label: item.name};
                           })}/>
                </div>
                <div className={'col-6'}>
                    <Button
                        className={'p-button-success p-button-outlined p-button-icon-only'}
                        style={{left: '0', bottom: '0'}}
                        disabled={!props.edit || selectedCommentType == null}
                        type={'button'} icon={'pi pi-plus'} onClick={() => {
                        append({
                            'ersteller': getUserFromLocalStorage().first_name + ' ' + getUserFromLocalStorage().last_name,
                            'kommentar': '',
                            'kommentar_type_id': selectedCommentType,
                            'type': getCommentTypeName(selectedCommentType),
                            'zeitstempel': new Date().toISOString()
                        });
                        setSelectedCommentType(undefined);
                    }}/>
                </div>
                <div className={'col-12'}>{
                    fields.map((item, index) => {
                        return getCommentField(item, index);
                    })
                }</div>
            </div>
            {props.kommentare && props.kommentare.length > 0 &&
            <CommentHistory comments={props.kommentare}/>}
        </>
    );
};
